import Vue from 'vue'
if (!Object.fromEntries) {
  Object.defineProperty(Object, 'fromEntries', {
    value: function (entries) {
      if (!entries || !entries[Symbol.iterator]) {
        Vue.$log.error('Object.fromEntries() requires a single iterable argument')
        return
      }

      const o = {}

      Object.keys(entries).forEach((key) => {
        const [k, v] = entries[key]

        o[k] = v
      })

      return o
    }
  })
}
